var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-fab md-primary",attrs:{"to":"/claim"}},[_c('md-icon',[_vm._v("generating_tokens")]),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("claim token for documentation")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }